<template><div>
    <div @click.stop.prevent="detail_click" class="cruise-info__services">Подробнее</div>

    <Modal v-model="isModalShown"
        title=""
        wrapper-class="animate__animated"
        modal-class="fill-modal"
        in-class="animate__zoomIn hideScroll"
        out-class="animate__zoomOut hideScroll">

        <div class="fill-modal__header fill-modal-header">
            <ModalTitle class="fill-modal-header__title" @close="isModalShown = false">
                {{props.excursion.name}}
            </ModalTitle>
        </div>

        <div class="fill-modal__content">
            <ExcursionInner :excursion="props.excursion" />
            <InsertHtml :html="props.excursion.description" link="pdf" />
        </div>

    </Modal>
</div>
</template>

<script setup>
import '@/comp/CruiseInList/CruiseInList.scss' // чтобы стили не попадали в сборку дважды     

import {ref,unref} from 'vue'
import ModalTitle from '@/comp/ModalTitle/ModalTitle.vue'
import Modal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import 'animate.css'
import ExcursionInner from './ExcursionInner.vue'
import InsertHtml from '@/comp/IncludedBlock/InsertHtml.vue'

const isModalShown = ref(false)

const props = defineProps({
    excursion: Object,
})

const detail_click = () => {
    isModalShown.value = true
}
</script>
